import React from 'react';
import {getBowserState} from '@epic-core/common';
import classNames from 'classnames';
import {getInitialCmsPageSharedValues, PageData, useCmsData} from 'epic-ue-shared';
import root from 'window-or-global';

import LoadIndicator from '../../components/common/loading/LoadIndicator';
import SliderCarousel from '../../components/home/SliderCarousel';

import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import Error404 from '../error/Error404';

const cmsUrlPattern = '/';

interface HomePageData extends PageData {
    sections: any;
}

const HomeView = (): JSX.Element => {
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<HomePageData>(cmsUrlPattern);

    if (cmsLoading) {
        return (
            <div id="home" className="eg-home">
                {getHelmetForMetaTags(pageData)}
                <LoadIndicator />
            </div>
        );
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    const {mobile, tablet} = getBowserState();

    const msedge =
        root._epicGamesNav && root._epicGamesNav.browser
            ? root._epicGamesNav.browser.msedge
            : false;

    const sections = pageData.sections || {};

    const responsive = [
        {
            breakpoint: 8000,
            slides: 3,
            autoScroll: true
        },
        {
            breakpoint: 1367,
            slides: 2,
            autoScroll: false
        },
        {
            breakpoint: 1025,
            slides: 1,
            autoScroll: false
        }
    ];

    const homeClasses = classNames('eg-sliderCarousel', {
        mobile,
        tablet,
        msedge
    });

    return (
        <div id="sliderCarouselHome" className={homeClasses}>
            {getHelmetForMetaTags(pageData)}
            <SliderCarousel responsive={responsive} driftSpeed={20} sections={sections} />
        </div>
    );
};

HomeView.getInitialSharedValues = getInitialCmsPageSharedValues(cmsUrlPattern);

export default HomeView;
